module.exports = window["core-js/modules/es.object.assign.js"];